<section class="py-14 md:py-24">
  <!-- Header -->
  <div data-aos="fade-up" class="mb-12">
    <span
      class="block text-[9px] leading-[15px] font-bold uppercase tracking-[2px] text-[#4A9EDB] mb-4"
    >
      {{ "talentSearchV2.talentPool.badge" | translate }}
    </span>

    <h2
      class="text-[32px] md:text-[44px] lg:text-[52px] leading-[1.27] lg:leading-[66px] font-[900] tracking-[-2px] text-white mb-4"
      [innerHTML]="'talentSearchV2.steps.title' | translate | accent">
    </h2>
  </div>

  <!-- Step cards -->
  <div class="grid grid-cols-1 lg:grid-cols-3 gap-3.5">
    <div
      *ngFor="let step of steps; let i = index"
      data-aos="fade-up"
      [attr.data-aos-delay]="i * 100"
    >
      <!-- Image -->
      <app-responsive-img
        [name]="step.imageName"
        [alt]="step.titleKey | translate"
        imgClass="w-full h-auto block select-none pointer-events-none"
        sizes="(min-width: 1024px) 33vw, 100vw"
      />
    </div>
  </div>

  <!-- Footer link -->
  <div class="text-center mt-10" data-aos="fade-up">
    <button
      type="button"
      (click)="openBookDemo()"
      class="text-sm leading-none font-semibold hover:underline text-[#4A9EDB]"
    >
      {{ "talentSearchV2.steps.viewPlans" | translate }}
      <span class="rtl:flip inline-grid place-items-center">
        <app-icon name="tabler:arrow-narrow-right" size="14" />
      </span>
    </button>
  </div>
</section>
